import styles from './ClaimSearchHeader.module.scss'
import { ClaimSearchHeaderProps } from './ClaimSearchHeader.types'
import { useTranslation } from 'react-i18next'
import { ClaimSearchHeaderForm } from '../ClaimSearchHeaderForm/ClaimSearchHeaderForm'
import { useLocation } from 'react-router-dom'
import { Alert, Card, Flex, Heading, Spacer } from '@percent/lemonade'

export function ClaimSearchHeader({ onSearchClick }: ClaimSearchHeaderProps) {
  const { t } = useTranslation()
  const { state } = useLocation()

  return (
    <Card className={styles.mainCard}>
      <Flex direction="column" p={24} w="100%">
        <div>
          <Heading level="h6" align="left">
            {t('typography.claimYourOrganization')}
          </Heading>
          {state?.organizationNotFoundAlert && (
            <>
              <Spacer size={4} axis="vertical" />
              <Alert variant="error" title={t('typography.alertFindYourOrganization')} />
            </>
          )}
        </div>
        <ClaimSearchHeaderForm onSearchClick={onSearchClick} />
      </Flex>
    </Card>
  )
}
